import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24')
];

export const server_loads = [];

export const dictionary = {
		"/(loggedin)": [11,[4]],
		"/(loggedin)/cp": [12,[4,5]],
		"/(loggedin)/cp/billing": [19,[4,5]],
		"/(loggedin)/cp/contact": [23,[4,5]],
		"/(loggedin)/cp/dashboard": [16,[4,5]],
		"/(loggedin)/cp/eatcoins": [13,[4,5]],
		"/(loggedin)/cp/logout": [14,[4,5]],
		"/(loggedin)/cp/menus": [22,[4,5]],
		"/(loggedin)/cp/reservations": [17,[4,5,6]],
		"/(loggedin)/cp/reservations/[when]": [18,[4,5,6]],
		"/(loggedin)/cp/reviews": [20,[4,5]],
		"/(loggedin)/cp/settings": [15,[4,5]],
		"/(loggedin)/cp/timetable": [21,[4,5]],
		"/(nouser)/forgot": [9,[2]],
		"/(nouser)/login": [7,[2,3]],
		"/sentry-test": [24],
		"/(nouser)/u/[hash]/changepass": [10,[2]],
		"/(nouser)/v/[id]/[hash]": [8,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';